import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Scrollchor from 'react-scrollchor';

const animate = {
  offset: -60,
  duration: 400,
};

const MenuList = ({ tt, list, lang, className, onClick }) => (
  <ul className={className}>
    {list.map(item => (
      <li key={`item-${item}`}>
        <Scrollchor
          animate={animate}
          to={`#${item}`}
          afterAnimate={onClick}
        >
          {tt.menu[item]}
        </Scrollchor>
      </li>
    ))}
    {lang.map(item => (
      <li key={`item-${item}`}>
        <Link to={`/${item}`} onClick={onClick}>{tt.lang[item]}</Link>
      </li>
    ))}
  </ul>
);

export default MenuList;

MenuList.propTypes = {
  tt: PropTypes.object,
  list: PropTypes.array,
  lang: PropTypes.array,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

MenuList.defaultProps = {
  tt: {},
  list: [],
  lang: [],
  onClick: () => {},
  className: '',
};



// WEBPACK FOOTER //
// ./src/blocks/MenuList/index.js